export default __webpack_public_path__ + "static/media/01Jabalpur.ab565119.jpg";